<!--
*****************************************************************************
*File : yard.vue
*Module : Dashboard Frontend
*Purpose : Displa the yard view for a selected date.
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->
<template>
<v-container
    id="calendar"
    fluid
    tag="section"
  >
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="800">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :value="getEventValues"
          :event-text-color="getTextColor"
          :event-color="getEventColor"
          :events="events"
          :type="type"
          @click:day="viewDay"        
          @click:date="viewDay"
          @change="updateRange"
        >        
        </v-calendar>
      </v-sheet>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Api from '@/views/service/api'
import ApiResponse from '../service/api-response'

  export default {
    data: () => ({
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      selectedEvent1: {},
      selectedElement1: null,
      selectedOpen1: false,
      events: [],
      values1: [], 
      monthData: [],
      entry_Arr: [],
      exit_Arr: [],
      unloadEntryTS_Arr: [],
      unloadExitTS_Arr: [],
      avg_time_taken: '',
      torpedo_long_wait: '',
      torpedoCntArr: [],
      countMvis: [],
      countWagon: [],
      countFwild: [],
      names: ['Number of Trains', 'Number of Wagons', 'MVIS Defects'],
    }),
    mounted () {
      this.$refs.calendar.checkChange();
      this.updateRange(this.$store.state.start_endYard);   
    
    },
    methods: {

      viewDay ({ date }) {
        this.focus = date
        this.$store.state.playDateInfo = date

        this.$router.push({ name: 'Day View', params: { date1: this.$store.state.playDateInfo } })

      },
      getEventColor (event) {
        return event.eventColor
      },
      getTextColor (event) {
        return event.textColor
      },
      getEventValues (event) {
        return event.value
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },

     
      updateRange ({ start, end }) {
        this.$store.state.start_endYard = { start, end }
        const events = []

        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)

        const days = (max.getTime() - min.getTime()) / 86400000

        function daysInMonth (month, year) {
            return new Date(year, month, 0).getDate();
        }
        const eventCount = daysInMonth(start.month, start.year);        

        const firstTimestamp1 = min.getTime() 
        var monT1 = new Date(firstTimestamp1).getMonth()
        var yearT = new Date(firstTimestamp1).getFullYear()
	      monT1 = monT1 + 1
        
        // prefix zero for single digit number
        monT1 = (monT1 < 10 ? '0' : '') + monT1 

        // Reading the dB (Passing the Month)
        Api().post('/api/yard_perf', {
            monthVal: monT1,
            yearVal: yearT
          }).then(response => {
            if (response.data != '') {
              this.monthData = response.data;
              this.torpedoCntArr = this.monthData.countTorpedo;
              this.countMvis = this.monthData.countMvis;
              this.countWagon = this.monthData.countWagon;
              this.countFwild = this.monthData.countFwild;
              
              fillMonthView.apply(this, this.entry_Arr, this.exit_Arr);
            }

          }).catch(error => {
            ApiResponse.checkErrorCode(error.response.status);
          })


      function timeDifference(date1,date2) {    

      var d1 = new Date(0);
      var d2 = new Date(0);
      var d3 = new Date(0);
      d1.setUTCSeconds(date1);
      d2.setUTCSeconds(date2);

      var diffSec_temp, diffMin_temp, hr_temp;
      var diffHr = 0, diffMin, diffSec;

      diffSec_temp = (d1.getTime() - d2.getTime()) / 1000;

      if((diffSec_temp / 60) > 60) {
        diffMin_temp = parseInt(diffSec_temp / 60);
        hr_temp = 1;
        while((hr_temp * 60) < diffMin_temp) {
          hr_temp++;
        }
        diffHr = hr_temp - 1; //to get the prev hour value
        diffMin = diffMin_temp - (diffHr * 60); //to get the minute value
        diffSec = parseInt(((diffSec_temp / 60) % 1) * 60); //to get the seconds value
      }
      else {

      diffMin = parseInt(diffSec_temp / 60); //to get minutes (quotient only)
      diffSec = diffSec_temp - (diffMin * 60);

      }     

      return diffHr + ' ' + 'hours' + ' ' + diffMin + ' ' + 'minutes' + ' ' + diffSec + ' ' + 'seconds';

    }

    function convertToSec(timeChk) {
      var timeSlice = [];
      var secondsSum = 0;

      timeSlice = timeChk.split(' '); // split it at the colons
      secondsSum = secondsSum + (+timeSlice[0]) * 60 * 60 + (+timeSlice[2]) * 60 + (+timeSlice[4]); 
      
      return secondsSum;
    }

    function sec2time(timeInSeconds) {
    var pad = function(num, size) { return ('000' + num).slice(size * -1); },
    time = parseFloat(timeInSeconds).toFixed(3),
    hours = Math.floor(time / 60 / 60),
    minutes = Math.floor(time / 60) % 60,
    seconds = Math.floor(time - minutes * 60),
    milliseconds = time.slice(-3);

    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2) ;
    }

    // longer waiting time of torpedo
    function monthView_longer_time(ts1, ts2) {  

      var timeIndx = 0;
      var timeChk = [];
      var secMax = 0;
      var longTime = '';

      while((timeIndx < ts1.length) && (timeIndx < ts2.length)) {

        timeChk[timeIndx] = timeDifference(ts2[timeIndx], ts1[timeIndx]);
        timeIndx++;
      }
      
      secMax = getMaxTime(timeChk)
      longTime = sec2time(secMax);

      for(timeIndx = 0; timeIndx < 31; timeIndx++) {
        timeChk[timeIndx] = timeIndx;
      }
      if(timeIndx != 0) {
        return longTime;
      }
      else {
        return null;
      }
      
    }

    function getMaxTime(timeChk) {
      var timeSlice = [];
      var timeIndxLoc = 0;
      var secondsMax = 0;
      var secondsMaxTemp = 0;

      while(timeIndxLoc < timeChk.length) {
        timeSlice = timeChk[timeIndxLoc].split(' '); // split it at the colons
        secondsMaxTemp = ((+timeSlice[0]) * 60 * 60 + (+timeSlice[2]) * 60 + (+timeSlice[4])); 
        if(secondsMaxTemp > secondsMax)
        {
          secondsMax = secondsMaxTemp;
        }
        timeIndxLoc = timeIndxLoc + 1;
      }      
      return secondsMax;
    }
        
    function sec2time(timeInSeconds) {
    var pad = function(num, size) { return ('000' + num).slice(size * -1); },
    time = parseFloat(timeInSeconds).toFixed(3),
    hours = Math.floor(time / 60 / 60),
    minutes = Math.floor(time / 60) % 60,
    seconds = Math.floor(time - minutes * 60),
    milliseconds = time.slice(-3);

    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2) ;
    }

        function fillMonthView() {

          var entry_ArrCnt = 0;
          var entry_DateArr = [];
          var exit_DateArr = [];
          var hhmmss_Arr = [];
          var Time_2_SecArr = [];
          var noEntries = [];
          var avgTime_MonthView = [];
          var lng_MonthView = [];
          var lng_Time_2_SecArr = [];
          var lng_noEntries = [];
          var lngTime_MonthView = [];

          //REST VALUE TO ZERO
          for(let tempIndx = 0; tempIndx < eventCount;  tempIndx++) {
            entry_DateArr[tempIndx] = 0;
            exit_DateArr[tempIndx] = 0;
            Time_2_SecArr[tempIndx] = 0;
            noEntries[tempIndx] = 0;
            avgTime_MonthView[tempIndx] = '';
            lng_MonthView[tempIndx] = 0;
            lngTime_MonthView[tempIndx] = '';
            lng_Time_2_SecArr[tempIndx] = 0;
            lng_noEntries[tempIndx] = 0;
          }

          //CONVERT UTC TO HHMMSS FORMAT - AVERAGE TRAIN TIME
          var timeIndx = 0;
          while((timeIndx < this.entry_Arr.length) && (timeIndx < this.exit_Arr.length)) {
            var dateEntry = this.convertTimestamp_date(this.entry_Arr[timeIndx]);
            var dateExit = this.convertTimestamp_date(this.exit_Arr[timeIndx]);
            var hhmmss = '';
            var totalSec = 0;
            var dateIndx = 0;

            if(dateEntry == dateExit) {
              dateIndx = (parseInt(dateEntry) - 1);
              hhmmss = timeDifference(this.exit_Arr[timeIndx], this.entry_Arr[timeIndx]);
              totalSec = convertToSec(hhmmss);
              
              Time_2_SecArr[dateIndx] = Time_2_SecArr[dateIndx] + parseInt(totalSec);
              noEntries[dateIndx] = noEntries[dateIndx] + 1;
            }
            timeIndx++;
          }


          for(var avgI = 0; avgI < 31; avgI++) {
            if(noEntries[avgI] != 0) {
              // avg_MonthView[avgI] = Time_2_SecArr[avgI] / noEntries[avgI];
              var avg_MonthView = Time_2_SecArr[avgI] / noEntries[avgI];
              avgTime_MonthView[avgI] = sec2time(avg_MonthView);
            }
          }

          //CONVERT UTC TO HHMMSS FORMAT - LONGER WAITING TIME
          var timeIndx = 0;
          while((timeIndx < this.entry_Arr.length) && (timeIndx < this.unloadEntryTS_Arr.length)) {
            var dateEntry = this.convertTimestamp_date(this.entry_Arr[timeIndx]);
            var dateExit = this.convertTimestamp_date(this.unloadEntryTS_Arr[timeIndx]);
            var hhmmss = '';
            var totalSec = 0;
            var dateIndx = 0;

            if(dateEntry == dateExit) {
              dateIndx = (parseInt(dateEntry) - 1);
              hhmmss = timeDifference(this.unloadEntryTS_Arr[timeIndx], this.entry_Arr[timeIndx]);
              totalSec = convertToSec(hhmmss);
              
              if(parseInt(totalSec) >= lng_Time_2_SecArr[dateIndx])
              {
                lng_Time_2_SecArr[dateIndx] = parseInt(totalSec);
              }
              lng_noEntries[dateIndx] = lng_noEntries[dateIndx] + 1;
            }
            timeIndx++;
          }

          for(var avgI = 0; avgI < 31; avgI++) {
            if(lng_noEntries[avgI] != 0) {
              lngTime_MonthView[avgI] = sec2time(lng_Time_2_SecArr[avgI]);
            }
          }

          //ENTRY TIMESTAMP
          for(let rowEntry_ArrIndx = 0; rowEntry_ArrIndx < (this.entry_Arr.length-1);  rowEntry_ArrIndx++) {
            //FIRST VALUE
            var dateOnly1 = this.convertTimestamp_date(this.entry_Arr[rowEntry_ArrIndx]);
            var monthOnly1 = this.convertTimestamp_month(this.entry_Arr[rowEntry_ArrIndx]);
            var yearOnly1 = this.convertTimestamp_year(this.entry_Arr[rowEntry_ArrIndx]);
            var dateCntr = 1;

            for(let colEntry_ArrIndx = (rowEntry_ArrIndx+1); colEntry_ArrIndx < (this.entry_Arr.length);  colEntry_ArrIndx++) {
              //SECOND VALUE
              var dateOnly2 = this.convertTimestamp_date(this.entry_Arr[colEntry_ArrIndx]);
              var monthOnly2 = this.convertTimestamp_month(this.entry_Arr[colEntry_ArrIndx]);
              var yearOnly2 = this.convertTimestamp_year(this.entry_Arr[colEntry_ArrIndx]);
              
              if ((dateOnly1 == dateOnly2) && (monthOnly1 == monthOnly2) && (yearOnly1 == yearOnly2)) {
                  dateCntr = dateCntr + 1;
                }
            }

            //Checking whether data is already considered for count / not 
            if(entry_DateArr[parseInt(dateOnly1)-1] == 0)
            {
              entry_DateArr[parseInt(dateOnly1)-1] =  dateCntr;
            }
          }

          //FOR LAST ELEMENT OF ARRAY
          var dateOnly1 = this.convertTimestamp_date(this.entry_Arr[this.entry_Arr.length-1]);
          if(entry_DateArr[parseInt(dateOnly1)-1] == 0)
          {
            entry_DateArr[parseInt(dateOnly1)-1] =  1;
          }


          //EXIT TIMESTAMP
          for(let rowExit_ArrIndx = 0; rowExit_ArrIndx < (this.exit_Arr.length-1);  rowExit_ArrIndx++) {
            //FIRST VALUE
            var dateOnly1 = this.convertTimestamp_date(this.exit_Arr[rowExit_ArrIndx]);
            var monthOnly1 = this.convertTimestamp_month(this.exit_Arr[rowExit_ArrIndx]);
            var yearOnly1 = this.convertTimestamp_year(this.exit_Arr[rowExit_ArrIndx]);
            var dateCntr = 1;

            for(let colExit_ArrIndx = (rowExit_ArrIndx+1); colExit_ArrIndx < (this.exit_Arr.length);  colExit_ArrIndx++) {
              //SECOND VALUE
              var dateOnly2 = this.convertTimestamp_date(this.exit_Arr[colExit_ArrIndx]);
              var monthOnly2 = this.convertTimestamp_month(this.exit_Arr[colExit_ArrIndx]);
              var yearOnly2 = this.convertTimestamp_year(this.exit_Arr[colExit_ArrIndx]);

              if ((dateOnly1 == dateOnly2) && (monthOnly1 == monthOnly2) && (yearOnly1 == yearOnly2)) {
                  dateCntr = dateCntr + 1;
                }
            }
            //Checking whether data is already considered for count / not 
            if(exit_DateArr[parseInt(dateOnly1)-1] == 0)
            {
              exit_DateArr[parseInt(dateOnly1)-1] =  dateCntr;
            }
          }

          //FOR LAST ELEMENT OF ARRAY
          var dateOnly1 = this.convertTimestamp_date(this.exit_Arr[this.exit_Arr.length-1]);
          if(exit_DateArr[parseInt(dateOnly1)-1] == 0)
          {
            exit_DateArr[parseInt(dateOnly1)-1] =  1;
          }


        for (let dayCntIndx = 0; dayCntIndx < eventCount; dayCntIndx++) {

          const firstTimestamp = min.getTime()      
          var first = new Date(firstTimestamp)
          var dateT = new Date(firstTimestamp).getDate()
          var monT = new Date(firstTimestamp).getMonth()
          var yearT = new Date(firstTimestamp).getFullYear()

          var newDate = yearT + '.' + monT + '.' +  (dateT+1);

          var curDayUnix = new Date(Date.UTC(yearT,monT,(dateT+dayCntIndx)));
          var curDay = new Date(curDayUnix);

          var nextDayUnix = new Date(Date.UTC(yearT,monT,(dateT+dayCntIndx+1)));
          var nextDay = new Date(nextDayUnix);

          var second = new Date(first.getDate() + 1);

          if(this.torpedoCntArr[dayCntIndx] != 0) {
            events.push({       
            name: 'No. of Trains: ' + this.torpedoCntArr[dayCntIndx],
            start: curDay,
            end: curDay,
            eventColor: 'rgb(255, 0, 0, 0)',
            textColor: '#00cae3',
            value: 2,
          })
          }
      
        if(this.countWagon[dayCntIndx] != 0) {
          events.push({
          
            name: 'No. of Wagons: ' + this.countWagon[dayCntIndx],
            start: curDay,
            end: curDay,
            eventColor: 'rgb(255, 0, 0, 0)',
            textColor: '#4caf50',
            value: 3,
          })
        }

        if(this.countMvis[dayCntIndx] != 0) {
          events.push({
            name: 'MVIS Defects: ' + this.countMvis[dayCntIndx],
            start: curDay,
            end: curDay,
            eventColor: 'rgb(255, 0, 0, 0)',
            textColor: '#F44336',
            value: 4,
          })
        }

        }
        }

        this.events = events
        
      }, //updateRange 
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      convertTimestamp_date(timestamp) {
          var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
          yyyy = d.getFullYear(),
          mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
          dd = ('0' + d.getDate()).slice(-2),			// Add leading 0.
          time;

        time =  dd; //+ ' ' + ampm
          
        return time;
      },
      convertTimestamp_month(timestamp) {
          var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
          yyyy = d.getFullYear(),
          mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
          time;
          
        time =   mm; //+ ' ' + ampm
          
        return time;
      },
      convertTimestamp_year(timestamp) {
          var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
          yyyy = d.getFullYear(),
          time;
          
        time =  yyyy; 
          
        return time;
      },
    },
  }
</script>

<style lang="scss">
.my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #ffffff;
    color: #000000;
    border: 1px solid #ffffff;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    margin-bottom: 1px;
  }
</style>
